import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { NgbModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { MatchHeightModule } from '../shared/directives/match-height.directive';
import { MatSelectModule, MatSlideToggleModule } from '@angular/material';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HomeComponent } from './home/home.component';
import { TosComponent } from './terms-of-service/tos/tos.component';
import { InterpretingResultsComponent } from './interpreting-results/interpreting-results.component';
import { UserGuideComponent } from './user-guide/user-guide.component';
import { GlossaryComponent } from './glossary/glossary.component';
import { RateMethodologyComponent } from './rate-methodology/rate-methodology.component';

@NgModule({
    imports: [
        NgxSpinnerModule,
        NgbDropdownModule,
        CommonModule,
        DashboardRoutingModule,
        MatSlideToggleModule,
        NgbModule,
        MatchHeightModule,
        MatSelectModule
    ],
    exports: [],
    declarations: [
        HomeComponent,
        TosComponent,
        InterpretingResultsComponent,
        UserGuideComponent,
        GlossaryComponent,
        RateMethodologyComponent,
    ],
    providers: [],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class DashboardModule { }
